import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token, getUserInfoCompanyId, getUserInfo } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT, SELECT_VAL_TYPE_STRING } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchBrLine, SearchHidden, SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getRetailList } from '../../../../../api/Beer/apiRetail';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_string, get_activation_color } from '../../../../../item/MyStat/ItemMyStatBase';
import { getAddrCityList, getAddrDistList, getInChargeDistributionList, getInChargeSalesList, getPurviewString, PURVIEW_DISTRIBUTOR, PURVIEW_MANAGER, PURVIEW_SPECIALIST, ReqRetailList, TITLE_RetailAddrCity, TITLE_RetailAddrDist } from '../../../../../item/Beer/ItemRetail';

export function RetailList({ id, setIsLoading, purview = PURVIEW_DISTRIBUTOR }) {
    const [userInfo, setUserInfo] = useState({})
    const [tokenId, setTokenId] = useState("")

    const [searchItems, setSearchItems] = useState([])

    const [retailList, setRetailList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    const [RetailName, set_RetailName] = useState("")

    const [InChargeSales, set_InChargeSales] = useState("")
    const [InChargeDistribution, set_InChargeDistribution] = useState("")
    const [inChargeSales_attr, setInChargeSales_attr] = useState([])
    const [inChargeDistribution_attr, setInChargeDistribution_attr] = useState([])

    const [RetailActivation, set_RetailActivation] = useState("")

    const [RetailAddrCity, set_RetailAddrCity] = useState("")
    const [RetailAddrDist, set_RetailAddrDist] = useState("")
    const [AddrCityList, set_AddrCityList] = useState([])
    const [AddrDistList, set_AddrDistList] = useState([])


    const [baseSearchBox, setBaseSearchBox] = useState(<></>)

    const [list_obj, set_list_obj] = useState({})

    useEffect(() => {
        getAddrCityList(setIsLoading, set_AddrCityList)
        getInChargeSalesList(getUserInfoCompanyId(), setIsLoading, setInChargeSales_attr)

    switch (purview) {
        case PURVIEW_MANAGER:
        case PURVIEW_SPECIALIST:
            getInChargeDistributionList(getUserInfoCompanyId(), setIsLoading, setInChargeDistribution_attr)
          break;
        case PURVIEW_DISTRIBUTOR:
          var userInfo = getUserInfo()
          setUserInfo(userInfo)
          set_InChargeDistribution(userInfo.departmentId)
        //   console.log(userInfo)
          break;
        default:
          break;
      }
    }, [])

    useEffect(() => {
        console.log(RetailAddrCity)
        if (RetailAddrCity !== '')
            getAddrDistList(RetailAddrCity, setIsLoading, set_AddrDistList)
    }, [RetailAddrCity])

    useEffect(() => {
        // console.log(searchItems)
    }, [searchItems])

    useEffect(() => {
        // console.log(baseSearchBox)
    }, [baseSearchBox])

    useEffect(() => {
        // if (inChargeSales_attr.length === 0)
        //     return
        // if (inChargeDistribution_attr.length === 0)
        //     return
        // if (AddrCityList.length === 0)
        //     return
        var searchItems = [
            [
                new SearchInput({
                    key: 'RetailName',
                    val: RetailName,
                    defaultVal: '',
                    title: '以客戶名稱搜尋',
                    col: 3
                }),
                new SearchSelect({
                    key: 'InChargeSales',
                    val: InChargeSales,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_STRING,
                    title: '以業務專員搜尋',
                    col: 3,
                    attr: inChargeSales_attr,
                    v: 'accountId',
                    n: 'nickName',
                    hasBlank: true,
                    blankVal: '',
                    blankOption: '全部'
                }),
                purview === PURVIEW_DISTRIBUTOR
                ?new SearchHidden({
                    key: 'InChargeDistribution',
                    val: InChargeDistribution,
                })
                :new SearchSelect({
                    key: 'InChargeDistribution',
                    val: InChargeDistribution,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_STRING,
                    title: '以經銷商搜尋',
                    col: 3,
                    attr: inChargeDistribution_attr,
                    v: 'departmentId',
                    n: 'departmentName',
                    hasBlank: true,
                    blankVal: '',
                    blankOption: '全部'
                }),
                new SearchSelect({
                    key: 'RetailActivation',
                    val: RetailActivation,
                    defaultVal: ACTIVATION_ENABLE,
                    valType: SELECT_VAL_TYPE_INT,
                    title: '客戶啟用狀態',
                    col: 3,
                    attr: search_activation_attr
                }),
                new SearchBrLine(),
                new SearchSelect({
                    key: 'RetailAddrCity',
                    val: RetailAddrCity,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: TITLE_RetailAddrCity,
                    col: 3,
                    attr: AddrCityList,
                    v: 'AddrCityID',
                    n: 'AddrCityName',
                    hasBlank: true,
                    blankVal: '',
                    blankOption: '全部'
                }),
                new SearchSelect({
                    key: 'RetailAddrDist',
                    val: RetailAddrDist,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: TITLE_RetailAddrDist,
                    col: 3,
                    attr: AddrDistList,
                    v: 'AddrDistID',
                    n: 'AddrDistName',
                    hasBlank: true,
                    blankVal: '',
                    blankOption: '全部'
                }),

            ],
            // new SearchBrLine()
        ]
        // console.log(searchItems)
        setSearchItems(searchItems)
    }, [inChargeSales_attr, inChargeDistribution_attr, AddrCityList, AddrDistList])

    useEffect(() => {
        console.log(searchItems)
        setBaseSearchBox(<BaseSearchBox action={toActionSearch} items={searchItems} onChange={onChange} />)
    }, [searchItems])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqRetailList = new ReqRetailList({ start, limit })
            if (url === "") {
                toSearch({ items: mReqRetailList, page: url.page })
            } else {
                mReqRetailList.fromJson(url)
                // console.log(mReqRetailList)
                toSearch({ items: mReqRetailList, page: url.page })
            }
        }
    }, [id])


    useEffect(() => {
        var contents = []
        retailList.forEach(item => {
            var content = []
            content.push(setTDLink({ link: getDetailUrl(), content: item.RetailName, key: 'RetailEdit', val: item }))
            content.push(setTD({ content: item.RetailContact + " / " + item.RetailPhone }))
            content.push(setTD({ content: item.RetailAddrCityName + item.RetailAddrCityName + item.RetailAddr }))
            content.push(setTD({ content: 0 }))
            content.push(setTD({ content: item.InChargeSalesName }))
            content.push(setTD({ content: item.InChargeDistributionName }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('客戶名稱', 2),
                new TableListTitle('窗口/電話', 2),
                new TableListTitle('客戶地址', 3),
                new TableListTitle('機器總數', 1),
                new TableListTitle('業務員', 2),
                new TableListTitle('經銷商', 2),
            ],
            contents
        }

        set_list_obj(lb)

    }, [retailList])


    function onChange(key, val) {
        console.log(key)
        console.log(val)
        switch (key) {
            case 'RetailName':
                set_RetailName(val)
                break;
            case 'InChargeSales':
                set_InChargeSales(val)
                break;
            case 'InChargeDistribution':
                set_InChargeDistribution(val)
                break;
            case 'RetailActivation':
                set_RetailActivation(val)
                break;
            case 'RetailAddrCity':
                set_RetailAddrCity(val)
                break;
            case 'RetailAddrDist':
                set_RetailAddrDist(val)
                break;
            default:
                break;
        }
    }

    function toActionSearch(searchItems) {
        console.log(searchItems)
        var mReqRetailList = new ReqRetailList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    console.log(item)
                    switch (item.key) {
                        case 'RetailName':
                            mReqRetailList.RetailName = item.val
                            break;
                        case 'InChargeSales':
                            mReqRetailList.InChargeSales = item.val
                            break;
                        case 'InChargeDistribution':
                            mReqRetailList.InChargeDistribution = item.val
                            break;
                        case 'RetailActivation':
                            mReqRetailList.RetailActivation = item.val
                            break;
                        case 'RetailAddrCity':
                            mReqRetailList.RetailAddrCity = item.val
                            break;
                        case 'RetailAddrDist':
                            mReqRetailList.RetailAddrDist = item.val
                            break;

                        default:
                            break;
                    }
                })
            }
        })
        // console.log(mReqRetailList)  
        setSearchItems(searchItems)
        toSearch({ items: mReqRetailList })
    }

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        if(purview === PURVIEW_DISTRIBUTOR){
            var userInfo = getUserInfo()
            items.InChargeDistribution = userInfo.departmentId
        }
        console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqRetailList = new ReqRetailList({ start, limit })
        if (items !== undefined)
            mReqRetailList.fromJson(items)
        // setReqRetailList(mReqRetailList)
        console.log(mReqRetailList)
        setVal2Token("url", mReqRetailList, id)
        getRetailList(mReqRetailList)
    }

    function getRetailList(mReqRetailList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqRetailList)
        api_getRetailList({
            mReqRetailList,
            success: (obj) => {
                console.log(obj)
                setRetailList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/BeerRetail_Add_" + getPurviewString(purview));
    }

    function getDetailUrl(){
        return "BeerRetail_Detail_" + getPurviewString(purview)
    }

    var baseTitle = "聯盟列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    {
                        purview === PURVIEW_DISTRIBUTOR
                            ? <></>
                            : <AddButton name={"新增"} action={toAdd} />
                    }

                </div>
            </div>
            <Space />
            <ListBox row={6} lb={list_obj} srl={setRetailList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            {baseSearchBox}
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

